<section class="p-r-30 flex-row flex-space-between-start">
    <app-page-header-title
        class="m-l-20 m-b-5"
        title="Customer Questionnaire"
    ></app-page-header-title>
</section>
<!--<mat-spinner *ngIf="cstQuestionnaireService.isLoading || customerQuestionnaireService.isLoading" class="m-auto m-t-20"></mat-spinner>-->
<ng-container>
    <div class="questionnaire-container m-t-10">
        <div class="sidenav">
            <app-overview-sidenav
                (allQuestionsAreReviewed)="onAllQuestionsReviewed($event)"
                (scrollToQuestionEmitter)="scrollToQuestionReceived($event)"
            ></app-overview-sidenav>
        </div>
        @if (!commonQuestionnaireService.createMode && !commonQuestionnaireService.reviewMode) {
        <div class="progress d-flex-center justify-center">
            <app-overview-progress></app-overview-progress>
        </div>
        } @if (cstQuestionnaireService.isLoading || customerQuestionnaireService.isLoading) {
        <div class="container m-t-100">
            <mat-spinner
                class="m-auto"
                [diameter]="60"
                [strokeWidth]="4"
            ></mat-spinner>
        </div>
        } @if (showStart() && !cstQuestionnaireService.isLoading && !customerQuestionnaireService.isLoading &&
        allQuestionnaireFilteredLoaded) { @if (customerQuestionnaireService.calculateAnsweredQuestions() === 0) {
        <app-start-questionnaire
            class="m-t-50"
            (emitStartQuestionnaire)="onResumeQuestionnaire($event, 'start')"
        ></app-start-questionnaire>
        } } @if (showSlideshow() && !cstQuestionnaireService.isLoading && !customerQuestionnaireService.isLoading &&
        allQuestionnaireFilteredLoaded) {
        <div class="questionnaire">
            <app-slideshow
                [scrollToQuestion]="scrollToQuestion"
                [reviewState]="commonQuestionnaireService.reviewMode"
            ></app-slideshow>
        </div>
        } @if (showResume() && !cstQuestionnaireService.isLoading && !customerQuestionnaireService.isLoading &&
        allQuestionnaireFilteredLoaded) {
        <app-resume-questionnaire (ResumeQuestionnaire)="onResumeQuestionnaire($event, 'resume')"></app-resume-questionnaire>
        } @if (showCheckSubmit() && !cstQuestionnaireService.isLoading && !customerQuestionnaireService.isLoading &&
        allQuestionnaireFilteredLoaded) {
        <app-check-submit
            class="d-flex-center justify-center"
            (resumeQuestionnaire)="onResumeQuestionnaire($event.status, $event.type, $event.isContinue)"
        ></app-check-submit>
        } @if (showNoQuestions() && !cstQuestionnaireService.isLoading && !customerQuestionnaireService.isLoading &&
        allQuestionnaireFilteredLoaded) {
        <app-no-questions-created class="m-t-100"></app-no-questions-created>
        } @if (showFinishAllQuestionnaire() && !cstQuestionnaireService.isLoading && !customerQuestionnaireService.isLoading &&
        allQuestionnaireFilteredLoaded) {
        <app-finished-questionnaire
            (resumeQuestionnaire)="onResumeQuestionnaire($event.status, $event.type)"
            imgType="noData"
            type="entire_questionnaire_finished"
        ></app-finished-questionnaire>
        } @if (showFinishAllMandatory() && !cstQuestionnaireService.isLoading && !customerQuestionnaireService.isLoading &&
        allQuestionnaireFilteredLoaded) {
        <app-finished-questionnaire
            [imgType]="'error'"
            (resumeQuestionnaire)="onResumeQuestionnaire($event.status, $event.type, $event.isContinue)"
            type="mandatory_questions_finished"
        ></app-finished-questionnaire>
        }
    </div>

    <div class="form-buttons flex-row flex-start-center flex-gap-16">
        @if (!commonQuestionnaireService.createMode && commonQuestionnaireService.reviewMode) {
        <button
            (click)="submitReviewActionButton()"
            [disabled]="customerQuestionnaireService.isLoadingSubmit"
            mat-flat-button
            id="questionnaire-review-submit-button"
            color="primary"
            type="submit"
            i18n
        >
            Submit Review
        </button>
        } @if (!commonQuestionnaireService.createMode && !commonQuestionnaireService.reviewMode) {
        <button
            (click)="customerQuestionnaireService.submitQuestions()"
            [disabled]="
                !customerQuestionnaireService.getModifiedQuestionsLength() ||
                customerQuestionnaireService.isLoading ||
                customerQuestionnaireService.isLoadingSubmit ||
                !customerQuestionnaireService.checkRequiredQuestionsAnswered()
            "
            mat-flat-button
            id="questionnaire-customer-submit-button"
            color="primary"
            type="submit"
            i18n
        >
            Submit
        </button>
        } @if (commonQuestionnaireService.createMode) {
        <button
            mat-flat-button
            color="primary"
            type="submit"
            i18n
            (click)="publishQuestionnaire()"
            [disabled]="
                cstQuestionnaireService.getTotalQuestions() === 0 ||
                isLoading ||
                cstQuestionnaireService.isLoading ||
                (cstQuestionnaireService.currentQuestionForm && !cstQuestionnaireService.currentQuestionForm.group.valid)
            "
        >
            Publish
        </button>
        }
    </div>
</ng-container>
